import React from 'react'
import { ApolloError } from '@apollo/client'
import times from 'lodash/times'
import { Table, TableBody, TableCell, TableHead, TableRow } from 'transfix-ui/components/Table'
import { makeStyles } from 'transfix-ui/core'
import ErrorInlineMessage from 'apps/marketplace/pages/shipment-details/components/ErrorInlineMessage'
import {
  ShipperTableRowEmpty,
  ShipperTableRowSkeleton,
} from 'apps/marketplace/pages/shippers/components/ShipperList/components/ShipperTable/components'
import { TItem } from 'apps/marketplace/pages/shippers/components/ShipperList/types'
import ShipperConfigDetailsTableRow from './ShipperConfigDetailsTableRow'

const useShipperTableStyles = makeStyles({
  table: {
    width: '100%',
  },
})

export const COLUMNS_COUNT = 5

interface IShipperListProps {
  error: ApolloError | undefined
  items: TItem[]
  isLoading: boolean
}

const ShipperConfigDetailsTable = ({
  isLoading,
  items: shippers = [],
  error,
}: IShipperListProps) => {
  const classes = useShipperTableStyles()
  const isEmpty = shippers.length === 0

  if (error) {
    return <ErrorInlineMessage />
  }

  return (
    <Table dataTest='ShipperTable' className={classes.table}>
      <TableHead>
        <TableRow tableCellType='th'>
          <TableCell>Name</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading &&
          times(20).map(index => {
            return <ShipperTableRowSkeleton key={index.toString()} />
          })}

        {!isLoading && isEmpty && <ShipperTableRowEmpty />}

        {!isLoading &&
          !isEmpty &&
          shippers.map((shipper, index) => {
            return <ShipperConfigDetailsTableRow key={index.toString()} shipper={shipper} />
          })}
      </TableBody>
    </Table>
  )
}

export default ShipperConfigDetailsTable
